export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TableView.vue?vue&type=template&id=22bf1949&"


//////////////////
// WEBPACK FOOTER
// ./src/views/TableView.vue?vue&type=template&id=22bf1949&
// module id = 549
// module chunks = 1